import { Component } from '@angular/core';
import { CbWebApi } from '../../services/cb-webapi';

@Component({
  selector: 'cb-unauthorize',
  templateUrl: './error-email-verification.component.html',
})
export class CbErrorEmailVerificationComponent {
  constructor(private cbWebApi: CbWebApi) {}

  gotoLogin() {
    this.cbWebApi.returnToAuthorizePage();
  }
}
